// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__3bxye","title":"ClientCherryInfo_title__984cx","itemText":"ClientCherryInfo_itemText__2DSrf"};